import { Directive, inject } from "@angular/core";
import { S25CardCarouselComponent } from "./s25.card.carousel.component";

/**
 * Apply this directive to every direct child of `s25-ng-card-carousel`. It:
 * - sets `role="listitem"` when the strip is in multi-card list mode (absent for a single card in region mode)
 * - applies the card width and snap-alignment that enforce the guaranteed "peek" of the next card
 *
 * Both guarantees are bundled in one directive so a consumer who omits it loses both at once,
 * making the omission obvious. The directive is meaningless outside a strip — the injection error
 * surfaces that immediately rather than silently misapplying the styles.
 *
 * Consumer responsibility (cannot be enforced here):
 * - Tab-order suppression inside clamped content
 * - Positional control naming (never content-derived)
 * - Focus restoration after item removal
 * - Polite AriaLive announcement on item removal
 * - NO auto-advance ever (violates WCAG 2.2.2)
 */
@Directive({
    selector: "[s25-ng-card-carousel-item]",
    standalone: true,
    host: {
        "[attr.role]": "strip.isMultiple() ? 'listitem' : null",
        "[attr.data-s25-card-carousel-item]": "''",
        "[style.flex]": "'0 0 auto'",
        "[style.width]": "'var(--s25-card-carousel-item-width, min(32rem, calc(100% - 3rem)))'",
        "[style.scroll-snap-align]": "'start'",
    },
})
export class S25CardCarouselItemDirective {
    readonly strip = inject(S25CardCarouselComponent);
}
